import FormattedCreditCard from "./FormattedCreditCard";

export default FormattedCreditCard;
